import React from "react";
import Modal from 'react-bootstrap/Modal';

const ModalTemplate = ({
    show,
    handleClose,
    size,
    centered,
    title,
    body,
    footer,
    isCustom,
    backdrop = "",
    keyboard = true,
    bodyBgColor = null
}) => {
    return (
        <Modal 
            show = {show} 
            onHide = {handleClose}
            centered = {centered}
            size = {size}
            backdrop = {backdrop}
            keyboard = {keyboard}
        >
            {title != null && (
                <Modal.Header closeButton = {handleClose != null}>
                    {isCustom ? title : <Modal.Title>{title}</Modal.Title>}
                </Modal.Header>
            )} 

            <Modal.Body style={{
                backgroundColor: bodyBgColor,
            }}>
                {body}
            </Modal.Body>

            {footer != null && (
                <Modal.Footer className="pb-0">
                    {footer}
                </Modal.Footer>  
            )} 
        </Modal>
    );
}

export default ModalTemplate;